import { render, staticRenderFns } from "./PendingApprovalSolicitorModal.vue?vue&type=template&id=24bdf3e8"
import script from "./PendingApprovalSolicitorModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalSolicitorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports